{
  "name": "tressi",
  "version": "0.0.12",
  "description": "A lightweight, declarative stress testing CLI for modern developers.",
  "license": "Unlicense",
  "keywords": [
    "performance",
    "load",
    "stress",
    "testing",
    "cli",
    "automation"
  ],
  "author": "kevinchatham",
  "type": "commonjs",
  "main": "dist/index.js",
  "bin": {
    "tressi": "dist/cli.js"
  },
  "scripts": {
    "build": "tsup",
    "format": "prettier --write . --config .prettierrc --ignore-path .prettierignore",
    "lint:inspect": "eslint --inspect-config",
    "lint:watch": "chokidar \"**/*.ts\" -c \"npm run lint\" --ignore \"**/node_modules/**\"",
    "lint": "eslint --fix --format unix --config ./eslint.config.mjs .",
    "prebuild": "npm run schema:generate",
    "pretest:dev": "npm run schema:generate",
    "pretest:autoscale": "npm run schema:generate",
    "pretest:basic": "npm run schema:generate",
    "pretest:ci": "npm run schema:generate",
    "pretest:ramp": "npm run schema:generate",
    "pretest:soak": "npm run schema:generate",
    "pretest:spike": "npm run schema:generate",
    "schema:generate": "tsx scripts/generate-schema.ts && npm run format",
    "start": "npm run build && node dist/cli.js",
    "test:dev": "tsx src/cli.ts --duration 60 --rps 5 --export temp/report",
    "test:autoscale": "tsx src/cli.ts --autoscale --workers 50 --rps 1000 --duration 15",
    "test:basic": "tsx src/cli.ts --workers 10 --duration 15 --rps 200",
    "test:ci": "tsx src/cli.ts --workers 5 --duration 15 --rps 300 --no-ui --export",
    "test:local": "concurrently -k \"tsx simple-server.ts\" \"sleep 2 && tsx src/cli.ts --config simple-server.json --workers 100 --duration 10 --no-ui\"",
    "test:ramp": "tsx src/cli.ts --workers 20 --duration 15 --rps 500 --ramp-up-time 10",
    "test:soak": "tsx src/cli.ts --workers 5 --duration 150 --rps 50",
    "test:spike": "tsx src/cli.ts --workers 100 --duration 10",
    "test:ui": "vitest --ui",
    "test": "npm run typecheck:tests && vitest run",
    "typecheck": "tsc --noEmit",
    "typecheck:tests": "tsc -p tsconfig.tests.json --noEmit"
  },
  "dependencies": {
    "blessed": "^0.1.81",
    "blessed-contrib": "^4.11.0",
    "chalk": "^5.4.1",
    "cli-table3": "^0.6.5",
    "commander": "^14.0.0",
    "hdr-histogram-js": "^3.0.1",
    "ora": "^8.2.0",
    "undici": "^7.3.0",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
    "zod": "^3.25.74"
  },
  "devDependencies": {
    "@eslint/eslintrc": "^3.1.0",
    "@types/blessed": "^0.1.25",
    "@types/node": "^22.0.0",
    "@vitest/ui": "^3.2.4",
    "chokidar-cli": "^3.0.0",
    "concurrently": "^9.2.0",
    "eslint-formatter-unix": "^8.40.0",
    "eslint-plugin-simple-import-sort": "^12.1.1",
    "prettier": "^3.5.3",
    "tsup": "^8.5.0",
    "tsx": "^4.20.3",
    "typescript": "^5.8.3",
    "typescript-eslint": "^8.1.0",
    "vitest": "^3.2.4",
    "zod-to-json-schema": "^3.24.6"
  }
}
